
export default class FadeIn {
	constructor() {
		this.init();
	}

	init() {
		document.addEventListener("DOMContentLoaded", function() {
			const elements = document.querySelectorAll('.fade-in');
			const options = {
					root: null,
					rootMargin: '0px',
					threshold: 0.1
			};

			const observer = new IntersectionObserver((entries, observer) => {
					entries.forEach(entry => {
						if (entry.isIntersecting) {
							entry.target.classList.add('active');
							observer.unobserve(entry.target);
						}
					});
			}, options);

			elements.forEach(element => {
					observer.observe(element);
			});
		});
	}
}
